/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ref_IntroInputs */

const en_to_xml_ref_intro = /** @type {(inputs: To_Xml_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each row is a real input fragment and the exact markup this tool emits.`)
};

const ko_to_xml_ref_intro = /** @type {(inputs: To_Xml_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 행은 실제 입력 조각과 이 도구가 내놓는 정확한 마크업입니다.`)
};

const ja_to_xml_ref_intro = /** @type {(inputs: To_Xml_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各行は実際の入力断片と、このツールが出す正確なマークアップです。`)
};

/**
* | output |
* | --- |
* | "Each row is a real input fragment and the exact markup this tool emits." |
*
* @param {To_Xml_Ref_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ref_intro = /** @type {((inputs?: To_Xml_Ref_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ref_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ref_intro(inputs)
	if (locale === "ko") return ko_to_xml_ref_intro(inputs)
	return ja_to_xml_ref_intro(inputs)
});